import { gql } from "@apollo/client";

export default gql`
  fragment WYSIWYGFragment on RichTextParagraph {
    id
    text {
      format
      processed
      value
    }
    alignment
    field_hub_rich_text_background
    field_remove_spacing
  }
`;
